import React from 'react';
import { PaintingDataType } from '../../../common/types';
import { getGalleryTNImageURL } from '../../../common/utilities/URLs/getURLs';
import './Painting.css';

interface PropsInterface {
  painting: PaintingDataType;
  handlePictureClick: (idx: number) => void;
  idx: number;
}

const Painting: React.FC<PropsInterface> = ({
  painting,
  handlePictureClick,
  idx,
}) => (
  <span
    className='Painting'
    onClick={ () => handlePictureClick(idx) }
    onKeyDown={ (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handlePictureClick(idx);
      }
    } }
    role='button'
    tabIndex={ 0 }
  >
    <img
      className='image'
      src={ getGalleryTNImageURL(painting.imgStem) }
      alt={ `${painting.name} project thumbnail` }
    />
    <span className='label'>{ painting.name }</span>
  </span>
);

export default Painting;
